import { render, staticRenderFns } from "./ListPriceLists.vue?vue&type=template&id=2f2e53f0&scoped=true"
import script from "./ListPriceLists.vue?vue&type=script&lang=js"
export * from "./ListPriceLists.vue?vue&type=script&lang=js"
import style0 from "./ListPriceLists.vue?vue&type=style&index=0&id=2f2e53f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e53f0",
  null
  
)

export default component.exports